module.exports = __webpack_public_path__ + "static/media/calculator.ec3f66ab.png";